import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { CommonModule } from '@angular/common';

import { GlobalsSingleton } from './GlobalsSingleton';
import { GlobalValues } from './GlobalValues';


@NgModule({
  imports:      [ CommonModule ],
  providers:    [ GlobalsSingleton ]
})
export class CoreModule {
  constructor (@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }

  static forRoot(): ModuleWithProviders {
console.log("!!! forRoot !!! forRoot !!! forRoot !!! forRoot !!! forRoot !!! forRoot !!! forRoot !!! forRoot !!! forRoot !!! forRoot !!! forRoot !!!");
    return {
      ngModule: CoreModule,
      providers: [
        {provide: GlobalValues, useValue: null }
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts